import {AdminUserAlert, ItemLoading, MenuBar, MenuOrderBy, MenuSearchTerm, OurClearAlert, OurPagination2, PageTitle} from "../../_components";
import React, {useRef, useState} from "react";
import {useGetJson, useLocalFilter2, useLongPress, useSelect} from "../../../hooks";
import {endpoints} from "../../../utils2";
import {Link, useParams, useSearchParams} from "react-router-dom";
import {useAuth} from "../../../context";
import {Badge, ListGroup, Stack} from "react-bootstrap";
import {useBrowserTitle} from "../../../hooks/useBrowserTitle";
import {ResponsiveContent} from "../../ResponsiveNavTabs";


export function Subscriptions() {
    useBrowserTitle("Subscriptions");
    return <ResponsiveContent body={<SubscriptionsBody/>}/>
}

function SubscriptionsBody() {
    const {uid} = useParams()
    const {authToken} = useAuth()
    const [searchParams] = useSearchParams()
    const search = {query: searchParams.get("query")}

    const [subCount, loadingSubCount, errorSubCount, clearErrorSubCount] = useGetJson(endpoints.subscription.count(uid, search), authToken?.jwt)
    const subscriptionCount = subCount?.data || 0

    const [subOrder, loadingSubOrder, errorSubOrder, clearErrorSubOrder] = useGetJson(endpoints.subscription.orderOptions(), authToken?.jwt)
    const orderOptions = subOrder?.data || []

    const searchL = {
        offset: Number(searchParams.get("index")) * Number(searchParams.get("size")),
        limit: Number(searchParams.get("size")),
        query: searchParams.get("query"),
        order_by: searchParams.get("by")
    }
    const [subList, loadingSubList, errorSubList, clearErrorSubList] = useGetJson(endpoints.subscription.list(uid, searchL), authToken?.jwt)
    const subscriptionList = subList?.data || []

    const filteredList = useLocalFilter2(subscriptionList, ["order_number"])

    // Select
    const [selList, toggleSelectItems, _, isItemSelected] = useSelect(subscriptionList)

    return <Stack>
        <AdminUserAlert/>
        <OurClearAlert variant="danger" msg={errorSubCount} onClear={clearErrorSubCount}/>
        <OurClearAlert variant="danger" msg={errorSubOrder} onClear={clearErrorSubOrder}/>
        <OurClearAlert variant="danger" msg={errorSubList} onClear={clearErrorSubList}/>

        <PageTitle title="Subscription">View {subscriptionList?.length} of {subscriptionCount} subscriptions.</PageTitle>

        <MenuBar>
            <MenuSearchTerm/>
            <MenuOrderBy orderOptions={orderOptions}/>
        </MenuBar>

        <ItemLoading show={loadingSubCount || loadingSubList || loadingSubOrder}/>

        {subscriptionList && subscriptionList.length > 0 ?
            <ListGroup variant="flush">
                {filteredList.map((item, index) =>
                    <RenderItem key={index}
                                item={item}
                                selected={isItemSelected(item.id)}
                                selectedCount={selList.length}
                                onSelect={toggleSelectItems}
                                to={`/backend/subscription/${uid}/${item.article_id}`}
                    />
                )}
            </ListGroup>
            :
            <span className="text-center">No subscriptions.</span>
        }

        <OurPagination2 loading={loadingSubCount || loadingSubList} itemCount={subscriptionCount}/>

    </Stack>
}

function RenderItem({item, selected, selectedCount, onSelect, to}) {
    const [show, setShow] = useState(false)

    const ref = useRef(null)
    useLongPress(ref, () => onSelect(item.id))

    return (
        <Stack direction="horizontal" gap="2" className={`mb-1 rounded ${selected && "hover-bg-secondary-subtle"}`}>
            <Stack ref={ref} direction="horizontal" className="flex-grow-1" gap="2">
                <div>
                    <i className="bi bi-award fs-2"/>
                </div>
                <div>
                    <Stack direction="vertical" className="" gap={0}>
                        <Link to={to}
                              className="flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                            <span className="text-wrap fw-semibold fs-4">{item.title}</span>
                        </Link>
                    </Stack>
                </div>
                <div className="ms-auto">
                    <Stack className="text-body-tertiary align-items-end justify-content-center" gap={0}>
                        <Badge bg={item?.is_active ? "success" : "danger"}>{item?.is_active ? "ACTIVE" : "INACTIVE"}</Badge>
                        {/*<span className="text-wrap fs-6 ">{`Valid until ${isoTimestampToReadableDateOnly(item.expiry_date)}`}</span>*/}
                        {/*<span className="text-wrap fs-6 ">{`${item.remaining_days} ${item.remaining_days > 1 ? "days" : "day"}  remaining`}</span>*/}
                    </Stack>
                </div>
            </Stack>

        </Stack>
    )
}
